<template>
    <div class="information"></div>
</template>

<script>
export default {
  name: "infomation",

  data() {
    return {};
  }
};
</script>

<style scoped>
.information {
  width: 4px;
  height: 85.55vh;
  background: rgba(8, 96, 87, 1);
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 11;
  right: 468px;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/index/infomation.vue